module.exports = __webpack_public_path__ + "next.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/next.png
// module id = 13
// module chunks = 0